"use strict";
/*
 * Created on 09 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductEANConverter_1 = require("./ProductEANConverter");
/**
 * @author Jaroslav Sevcik
 */


var ProductEANConverterImpl =
/*#__PURE__*/
function (_ProductEANConverter_) {
  _inherits(ProductEANConverterImpl, _ProductEANConverter_);

  function ProductEANConverterImpl() {
    _classCallCheck(this, ProductEANConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductEANConverterImpl).apply(this, arguments));
  }

  _createClass(ProductEANConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      return {
        value: source.value,
        dateFrom: source.dateFrom ? conversions.fromDate(source.dateFrom) : null,
        dateTo: source.dateTo ? conversions.fromDate(source.dateTo) : null,
        active: source.active,
        eanDescription: source.eanDescription
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return {
        value: source.value,
        dateFrom: source.dateFrom ? conversions.toDate(source.dateFrom) : null,
        dateTo: source.dateTo ? conversions.toDate(source.dateTo) : null,
        active: source.active,
        eanDescription: source.eanDescription
      };
    }
  }]);

  return ProductEANConverterImpl;
}(ProductEANConverter_1.ProductEANConverter);

exports.ProductEANConverterImpl = ProductEANConverterImpl;